import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import setup1 from "images/setup1.png";
import setup2 from "images/setup2.png";
import setup3 from "images/setup3.png";
import setup4 from "images/setup4.png";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

const WhatSetsUsApart = () => {
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);

  const content = [
    {
      title:
        " We stand out in the rental industry by prioritizing our customers. Our flexible age policy sets us apart from the rest. Unlike many rental companies that have age restrictions, we proudly serve renters as young as 21. We believe in inclusivity and ensuring that everyone can experience the freedom of the open road, regardless of age.",
      imgSrc: setup2,
    },
    {
      title:
        "At Blue Diamond, we believe car rental should be easy and accessible every day. Our fleet of well-maintained vehicles is available for booking whenever you need them. Whether you're planning ahead or need a car at the last minute, we make it simple to get the vehicle you want, when you want it. With our user-friendly website and responsive customer service, we ensure that renting a car is always quick, easy, and stress-free.",
      imgSrc: setup2,
    },
    {
      title:
        "At Blue Diamond, we know that convenience is key. That’s why we offer flexible drop-off and delivery options to make your rental experience as seamless as possible. Need a car delivered directly to your home, office, or airport? Or perhaps you prefer a quick drop-off at a location that suits your schedule? We’ve got you covered. Our mission is to provide you with a hassle-free experience, where we bring the car to you — wherever you are.",
      imgSrc: setup2,
    },
    {
      title:
        "Renting a car with Blue Diamond is all about simplicity and peace of mind. From the moment you book to the day you return your vehicle, we prioritize a hassle-free experience. Our easy booking process, transparent pricing, and straightforward policies ensure there are no hidden fees or surprises. With dedicated customer support available 24/7 and flexible rental options, we make sure your journey is smooth and stress-free from start to finish.",
      imgSrc: setup2,
    },
    // Add more content as needed
  ];

  const handleClick = (index: number) => {
    setActiveIndex(index);
  };

  return (
    <section>
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-white mb-12">
          What Sets Us Apart
        </h2>

        <h3 className="text-2xl font-semibold text-center text-primary-200 mb-4">
          Blue Diamond Enterprise:{" "}
          <span className="text-white">
            Your Trusted Partner in Adventure and Vehicle Care
          </span>
        </h3>
        <p className="text-[#F5F5F7CC] mb-6 ">
          <strong className="text-primary-200">
            {" "}
            We’re not just another car rental company;
          </strong>{" "}
          we’re your trusted partner in adventure and vehicle care. Founded out
          of a passion for cars and a desire to make reliable transportation
          accessible to everyone, we go beyond the basics of renting vehicles.
          At Blue Diamond Enterprise, we specialize in offering high-quality
          cars at competitive prices, with the added convenience of renting to
          those as young as 21. Our doors are open every day, ensuring you have
          access to reliable vehicles whenever you need them.
        </p>

        <div className="grid md:grid-cols-2 items-start gap-12">
          {/* Left Column */}

          {/* Right Column */}
        </div>
        <div className="grid md:grid-cols-2 items-start gap-12">
          <div className="space-y-8 flex-col flex">
            {[
              "Putting Customers First",
              "Accessibility Every Day",
              "Convenient Drop-off and Delivery",
              "Creating a Hassle-Free Experience",
            ].map((text, index) => (
              <span
                key={index}
                onClick={() => handleClick(index)}
                className={`${
                  activeIndex === index ? "bg-primary-200" : "bg-transparent"
                } text-white rounded-lg shadow px-6 py-4 max-w-sm text-left flex items-center justify-between cursor-pointer`}
              >
                {text}

                {activeIndex === index ? (
                  <ChevronRightIcon className="w-6 ml-2" />
                ) : (
                  <ChevronLeftIcon className="w-6 ml-2" />
                )}
              </span>
            ))}
          </div>

          <div>
            <p className="mb-2">{content[activeIndex].title}</p>
            <img src={content[activeIndex].imgSrc} alt="Content Image" />
          </div>
        </div>
        <div className="mt-6 mx-6">
          <p className="text-center">
            By choosing Blue Diamond Enterprise, you’re choosing a
            customer-centric approach, accessibility, convenience, and a
            commitment to providing a hassle-free experience. Our dedication to
            putting customers first, being available every day, and offering
            convenient services sets us apart and ensures that your rental
            experience with us is exceptional.
          </p>
        </div>
        {/* Call-to-Action */}
        <div className="mt-12 bg-[#FFFFFF1A] text-white py-8 rounded-lg grid md:grid-cols-2 justify-center  px-8">
          <div>
            <p className="text-xl text-left font-semibold items-center">
              Join the Blue Diamond family and discover a new standard in car
              rentals and care!
            </p>
          </div>
          {location.pathname === "/" && (
            <div className="flex flex-row mt-2 md:mt-0 justify-center md:justify-end items-center">
              <ButtonPrimary
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                Push to Start
              </ButtonPrimary>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default WhatSetsUsApart;
